import React, { useEffect, useRef, useState } from 'react';

function SignalAudioPlayer({ signal }) {
  const audioRef = useRef(null); 
  const [isUserInteracted, setIsUserInteracted] = useState(false);
  const [isAudioLoaded, setIsAudioLoaded] = useState(false);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (!isUserInteracted) {
        const audio = new Audio('/sounds/signal.mp3');

        audio.onerror = (e) => {
          console.error('Audio loading error:', e);
        };

        audio.addEventListener('canplaythrough', () => {
          setIsAudioLoaded(true);
        });

        audioRef.current = audio;
        setIsUserInteracted(true);
        window.removeEventListener('click', handleUserInteraction);
      }
    };

    window.addEventListener('click', handleUserInteraction);
    return () => window.removeEventListener('click', handleUserInteraction);
  }, [isUserInteracted]);

  useEffect(() => {
    if (signal && audioRef.current && isAudioLoaded) {
        audioRef.current.play().catch(err => {
          console.warn('Failed to play sound:', err);
        });    
    }
  }, [signal, isAudioLoaded]);

  return null;
}

export default SignalAudioPlayer;
